<template>
  <v-row
    dense
  >
    <!-- section1 -->
    <v-col
      v-for="key in keyMap.section1"
      :key="key.value"
      :class="{'d-flex':$vuetify.breakpoint.lgAndUp, 'pt-0': true}" 
      cols='12'
    >
      <span class="d-block">{{ key.name }}</span>
      <span
        :class="`ml-auto ${$vuetify.breakpoint.lgAndUp ? 'font-weight-bold':'font-weight-bold'}`"
      >
        <span v-if="key.value == 'is_vip'">{{ patient[key.value] ? 'Yes' : 'No' }}</span>
        <span v-if="key.value == 'has_warning'">{{ patient[key.value] ? patient[key.value] : 'No' }}</span>
        
        <span v-if="key.section == 'case' && key.section != 'is_vip' && key.section != 'has_warning' && caseInfo">
          {{ caseInfo[key.value] ? caseInfo[key.value] : 'N&frasl;A' }}
        </span>
        <span v-if="key.section == 'patient' && key.value != 'is_vip' && key.value != 'has_warning'">
          {{ patient[key.value] ? patient[key.value] : 'N&frasl;A' }}
        </span>
        <span v-if="key.section == 'user' && key.value != 'is_vip' && key.value != 'has_warning'">
          {{ user[key.value] ? user[key.value] : 'N&frasl;A' }}
        </span>
      </span>
    </v-col>

    <!-- divider -->
    <v-col
      cols="12"
      class="my-3"
    >
      <v-divider class="secondary darken-2"></v-divider>
    </v-col>

    <!-- section2 -->
    <v-col
      v-for="key in keyMap.section2"
      :key="key.value"
      :class="{'d-flex':$vuetify.breakpoint.lgAndUp, 'pt-0': true}" 
      cols='12'
    >
      <span class="d-block">{{ key.name }}</span>
      <span
        :class="`ml-auto ${$vuetify.breakpoint.lgAndUp ? 'font-weight-bold':'font-weight-bold'}`"
      >
        {{ patient[key.value] ? patient[key.value] : 'N&frasl;A' }}
      </span>
    </v-col>

    <!-- divider -->
    <v-col
      cols="12"
      class="my-3"
    >
      <v-divider class="secondary darken-2"></v-divider>
    </v-col>

    <!-- section3 -->
    <v-col
      :class="{'d-flex':$vuetify.breakpoint.lgAndUp, 'pt-0': true}" 
      cols='12'
    >
      <span class="d-block">Case</span>
      <span
        :class="`ml-auto ${$vuetify.breakpoint.lgAndUp ? 'font-weight-bold':'font-weight-bold'}`"
      >
        {{ caseInfo ? 'Case #' + caseInfo.id : 'N&frasl;A' }}
      </span>
    </v-col>
    <v-col
      :class="{'d-flex':$vuetify.breakpoint.lgAndUp, 'pt-0': true}" 
      cols='12'
    >
      <span class="d-block">Consult</span>
      <span
        :class="`ml-auto ${$vuetify.breakpoint.lgAndUp ? 'font-weight-bold':'font-weight-bold'}`"
      >
        {{ caseInfo ? caseInfo.consultations.length + ' (for this case)' : 'N&frasl;A' }}
      </span>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'CaseDetails',

    props: {
      caseInfo: { type: Object }
    },

    data: () => ({
      keyMap: {
        section1: [
          {name: 'Language', value: 'preferred_language', section: 'patient'},
          {name: 'Case Title', value: 'health_concern', section: 'case'},
          {name: 'Case No.', value: 'case_number', section: 'case'},
          {name: 'Caller Role', value: 'user_type', section: 'user'},
          {name: 'Provider name', value: 'insurance_provider', section: 'user'},
          {name: 'Insurance No.', value: 'insurance_number', section: 'user'},
          {name: 'Contact No.', value: 'mobile_number', section: 'patient'},
          {name: 'Company name', value: 'company_name', section: 'user'},
          {name: 'VIP', value: 'is_vip', section: 'patient'},
          {name: 'Warning', value: 'has_warning', section: 'patient'},
          {name: 'Warning reason', value: 'warning_reason', section: 'patient'},
        ],
        section2: [
          {name: 'Gender', value: 'gender', section: 'patient'},
          {name: 'Marital status', value: 'marital_status', section: 'patient'},
          {name: 'Age', value: 'age', section: 'patient'},
          {name: 'Birthdate', value: 'birthdate', section: 'patient'},
          {name: 'Height', value: 'height', section: 'patient'},
          {name: 'Weight', value: 'weight', section: 'patient'},
          {name: 'BMI', value: 'bmi', section: 'patient'},
          {name: 'Date measured', value: 'date_measured', section: 'patient'},
        ]
      }
    }),

    computed: {
      patient() {
        return this.caseInfo.patient.patient
      },
      user() {
        return this.caseInfo.patient
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>